import {DataLoader, renderNestedComponents} from '@wallaby-ui/core';
import React from 'react';

interface OwnProps {
  appDataLoaders: DataLoader[];
}
type Props = OwnProps;

export const ApplicationDataLoader: React.FC<Props> = (props) => {
  const {children, appDataLoaders} = props;

  return <>{renderNestedComponents(appDataLoaders, children)}</>;
};

ApplicationDataLoader.displayName = 'ApplicationDataLoader';
